module.exports = __webpack_public_path__ + "images/e7934727dbd2add04a0e6b5af5a7ac70d0b9f2590a27a4213c13ca51ad3084f4.svg";